import { Tabs } from '@intigral/shared';
import { MoreLikeThis } from './elements';
import { __ } from '../../../translations';
import { Tab1 } from './elements/Tab1';
import { Tab2 } from './elements/Tab2';
import { CastCrew } from './CastCrew';
import { Text } from '@intigral/shared';
import { iTabListProps } from '../types/iTabs';
import React from 'react';
import { PROGRAM_TYPES } from '../constants';

export const TabLists: React.FC<iTabListProps> = ({ item, ref, setRuntimeLength, seasons }) => {
    return (
        <>
            {item.programType !== PROGRAM_TYPES.SERIES ? (
                <>
                    <Text as="p" alignment="start" margin="4x" style={{ opacity: 0.9 }}>
                        {item?.description}
                    </Text>
                    <CastCrew
                        contentId={item.Id}
                        meta={{ title: { ar: __('cast_and_crew'), en: __('cast_and_crew') } }}
                        id="movie-details_popup_castcrew"
                    />
                    <div ref={ref}></div>
                    <MoreLikeThis item={item} />
                </>
            ) : (
                <Tabs
                    tabs={[
                        {
                            content: <Tab1 item={item} moreLikeThisRef={ref} />,
                            title: __('more_info'),
                        },
                        {
                            content: (
                                <Tab2
                                    setRuntimeLength={setRuntimeLength}
                                    seasons={seasons}
                                    seasonOrderDescending={item?.pl1$seasonOrderDescending ?? null}
                                />
                            ),
                            title: __('episodes'),
                        },
                    ]}
                />
            )}
        </>
    );
};
